theme.carousel = (function () {
  function carousel(container) {
    var $container = (this.$container = $(container)),
      sectionId = $container.attr('data-section-id'),
      carousel = $($container).find('.carousel'),
      tabs = (this.tabs = '#' + sectionId + ' .tablink'),
      tabcontent = (this.tabcontent = '#' + sectionId + ' .tab-content')

    $(tabs).on('click', function (e) {
      e.preventDefault()
      $(this).parent().addClass('active')
      $(this).parent().siblings().removeClass('active')
      var tab = $(this).attr('href')
      $(tabcontent).not(tab).css('display', 'none')
      $(tab).fadeIn()
      $(carousel).slick('refresh')
    })
    $('#' + sectionId).each(function () {
      $(this).find('.tabs-listing li:first-child').addClass('active')
      // $(this).find(".tab-container .acor-ttl:first-child").addClass("active");
      $(this).find('.tab-container .tab-content:first-child').show()
      var firsttab = $(this)
        .find('.collection-tabs ul li:first-child a')
        .attr('href')
    })

    $('#' + sectionId + ' .carousel-menu a').on('click', function (e) {
      e.preventDefault();

      $('#' + sectionId + ' .carousel-menu li').removeClass('active');
      $(this).parent().addClass('active');

      var blockId = $(this).data('blockid');
      var slideIndex = $('#productSlider-' + sectionId).find('[data-blockid="' + blockId + '"]').not('.slick-cloned').data('slick-index');

      $('#productSlider-' + sectionId).slick('slickGoTo', slideIndex);
    });

    $('#productSlider-' + sectionId).on('afterChange', function(event, slick, currentSlide, nextSlide){
      var blockId = $(this).find('.slick-active').data('blockid');
      setTimeout(function () {
        $('#' + sectionId + ' .carousel-menu li').removeClass('active');
        $('#' + sectionId + ' .carousel-menu').find('[data-blockid="' + blockId + '"]').parent().addClass('active');
      }, 100)
    });

    // Recenttly Viewed
    if (sectionId == 'recently-viewed') {
      var recentcookie = 'recentproducts',
        crproduct = $container.attr('data-pr')
      $.ajax({
        url:
          '/pages/recently-viewed-products/' +
          $.cookie(recentcookie) +
          '__pr=' +
          crproduct,
        dataType: 'html',
        type: 'GET',
        success: function (data) {
          if ($(data).find('.grid-view_image').length) {
            $('#productSlider-recently-viewed').html(data)
          }
        },
        error: function (data) {
          console.log('ajax error')
        },
        complete: function () {
          $(carousel).slick('refresh')
          if (theme.mlcurrency) {
            currenciesChange('#productSlider-recently-viewed span.money')
          }
        },
      })
    }
    if ($('#' + sectionId + '.recommended').length) {
      var baseUrl = $container.data('baseUrl'),
        productId = $container.data('productId'),
        limit = $container.data('limit'),
        productRecommendationsUrlAndContainerClass =
          baseUrl +
          '?section_id=product-recommendations&limit=' +
          limit +
          '&product_id=' +
          productId +
          ' .product-recommendations'
      $container.parent().load(productRecommendationsUrlAndContainerClass)
      $('#productSlider-product-recommendations').slick()
      setTimeout(function () {
        $('#productSlider-product-recommendations').slick()
      }, 1500)
    }

    if ($('.anchor-slick').length > 0) {
      $('.anchor-slick').on('click', function (e) {
        e.preventDefault()

        $('.anchor-slick.active').removeClass('active')
        $(this).addClass('active')
        $('.row-' + sectionId + ' .carousel').slick(
          'slickGoTo',
          $(this).attr('index') - 1
        )
      })

      $('.row-' + sectionId + ' .carousel').on(
        'beforeChange',
        function (event, slick, currentSlide, nextSlide) {
          $('.anchor-slick.active').removeClass('active')
          $('.anchor-slick').eq(nextSlide).addClass('active')
        }
      )
    }
    $(carousel).on('init', function (event, slick) {
      if ($container.hasClass('content-row--carousel')) {
        setTimeout(() => {
          calcHeightImage()
        }, 250)

        window.addEventListener('resize', () => {
          calcHeightImage()
        })

        function calcHeightImage() {
          const heinghImg = $container.find('.imgCol').height()
          const sclickArrow = $container.find('.slick-arrow')
          const sclickDots = $container.find('.slick-dots')

          if (window.matchMedia('(max-width: 749px)').matches) {
            var stylesArrow = {
              transform: 'none',
              top: `calc(${heinghImg}px / 2 - ${sclickArrow.height()}px / 2)`,
            }

            var stylesDots = {
              bottom: 'auto',
              top: `calc(${heinghImg}px - 20px)`,
            }

            sclickArrow.css(stylesArrow)
            sclickDots.css(stylesDots)
          } else {
            sclickArrow.removeAttr('style')
            sclickDots.removeAttr('style')
          }
        }
      }
    })

    // TrackPad check
    /*let isTrackpad = false;
    function detectTrackPad(e) {
      if (e.wheelDeltaX) {
        if (Math.abs(e.wheelDeltaX) !== 120) {
          isTrackpad = true;
        }
      } else {
        isTrackpad = false;
      }
      console.log(isTrackpad ? "Trackpad DeltaX detected" : "");
    }
    document.addEventListener("mousewheel", detectTrackPad, false);
    document.addEventListener("DOMMouseScroll", detectTrackPad, false);
    document.addEventListener("wheel", detectTrackPad, false);*/

    // TrackPad carousel scroll
    let blocked = false;
    let blockTimeout = null;
    $(carousel).on('wheel', (function(e) {
      clearTimeout(blockTimeout);
      blockTimeout = setTimeout(function(){
        blocked = false;
      }, 50);

      if ( e.originalEvent.deltaX !== 0 && !blocked ) {
        e.preventDefault();
        blocked = true;

        if (e.originalEvent.deltaX >= 10) {
          $(this).slick('slickNext');
        }
        if (e.originalEvent.deltaX <= -10) {
          $(this).slick('slickPrev');
        }
      }
    }));

    $(carousel).slick()
  }
  return carousel
})()
